import * as React from "react";

import { TabAppearance } from "common/generator/description";
import AppIcon from "common/app-icon";
import { TabBarStyle, TabStyle, ButtonContent, TabLabelStyle } from "./tab-bar-view-style";
import { TabWithVisibility } from "webapp/chrome/smart/material-glide-app/material-glide-app";
import { SelectMode, withSelectMode } from "sharedUI/lib/editor-select-mode-utils";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { DeviceFormFactor } from "common/render/form-factor";
import classNames from "classnames";

interface Props extends RouteComponentProps<{ page?: string }> {
    readonly selected: number;
    readonly hidden: boolean;
    readonly tabs: readonly TabWithVisibility[];
    readonly onTabSelect: (index: number, history?: RouteComponentProps["history"], selectMode?: SelectMode) => void;
    readonly sizeClass: DeviceFormFactor;
    readonly selectMode: SelectMode;
}

class TabBarView extends React.PureComponent<Props> {
    public state = {};

    handleTabSelect = (index: number) => {
        this.props.onTabSelect(index, this.props.history, this.props.selectMode);
    };

    public render(): React.ReactNode {
        const { selected, tabs, sizeClass, hidden, selectMode } = this.props;
        const isTablet = sizeClass !== DeviceFormFactor.Phone;

        return (
            <TabBarStyle id="tabBar" className={classNames(hidden ? "hidden" : "visible", sizeClass)}>
                <div className="tbs-inner" role="navigation">
                    {tabs.map((t, i) => (
                        <Tab
                            selected={selected === i}
                            key={i}
                            title={t.desc.title}
                            icon={t.desc.icon}
                            hidden={!t.isVisible}
                            inFlyout={t.desc.inFlyout}
                            onClick={() => this.handleTabSelect(i)}
                            isTablet={isTablet}
                            selectMode={selectMode}
                            page={this.props.match.params.page}
                        />
                    ))}
                </div>
            </TabBarStyle>
        );
    }
}

interface TabProps extends TabAppearance {
    key: number;
    onClick(): void;
    selected: boolean;
    isTablet: boolean;
    selectMode?: SelectMode;
    page?: string;
}

function Tab({ title, icon, onClick, selected, hidden, inFlyout, isTablet, selectMode, page }: TabProps): JSX.Element {
    if (hidden || inFlyout === true) return <React.Fragment />;
    return (
        <TabStyle
            focused={page === "tabs"}
            aria-label={title}
            role="tab"
            selected={selected}
            onClick={onClick}
            highlightedSelectMode={selectMode === "edit"}>
            <ButtonContent isTablet={isTablet}>
                <AppIcon icon={icon} />
                <TabLabelStyle isTablet={isTablet}>{title}</TabLabelStyle>
            </ButtonContent>
        </TabStyle>
    );
}

export default withRouter(withSelectMode(TabBarView));
